export const merchantCompanyState = {
  allMerchantCompanys: [],
  selectedMerchantCompany: null,
};
